import axiosInstance from './AxiosInstance';

const API_URL = 'employeeskills';

export const getEmployeeSkills = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching employeeskills', error);
        throw error;
    }
};

export const getEmployeeSkillById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching employeeskill with id ${id}`, error);
        throw error;
    }
};

export const getEmployeeSkillByEmail = async (email) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/recordbyemail`, {email: email});
        return response.data;
      } catch (error) {
        console.error("Error getting employee skill ", error);
        throw error;
      }
};

export const createEmployeeSkill = async (employeeskill) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, employeeskill);
        return response.data;
    } catch (error) {
        console.error('Error creating employeeskill', error);
        throw error;
    }
};

export const updateEmployeeSkill = async (id, employeeskill) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...employeeskill });
        return response.data;
    } catch (error) {
        console.error(`Error updating employeeskill with id ${id}`, error);
        throw error;
    }
};

export const deleteEmployeeSkill = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting employeeskill with id ${id}`, error);
        throw error;
    }
};

